// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","card__header":"Card_card__header__N4kiH","card__title":"Card_card__title__Gfuby","card__content":"Card_card__content__iG2TC"};